var map = {
	"./translation-1-de_DE.js": 85,
	"./translation-2-fr_FR.js": 86,
	"./translation-3-nl_NL.js": 87,
	"./translation-4-de_AT.js": 88,
	"./translation-5-de_CH.js": 89,
	"./translation-5-fr_CH.js": 90,
	"./translation-6-fr_BE.js": 91,
	"./translation-6-nl_BE.js": 92,
	"./translation-7-it_IT.js": 93,
	"./translation-8-de_DE.js": 94
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;



/*****************
 ** WEBPACK FOOTER
 ** ./generated ../~/promise-loader?global!^\.\/translation\-.*\.js$
 ** module id = 46
 ** module chunks = 20 21
 **/